import { global } from "./index.js";
import {synchronizeConsentInformation} from "../cookiebanner/domain/synchronizeConsentInformation.js";
import { trackAdvertisingId } from "../thirdpartytracking/trackAdvertisingId.js";
import { appType, appVersion, runningInApp } from "./detectionFunctions.js";
import { retrieveNativeAppEvents } from "./nativeappevent/nativeAppEvents.js";

void synchronizeConsentInformation().then(() => {
    void trackAdvertisingId();
});

global.assignNamespace({retrieveNativeAppEvents, runningInApp, appType, appVersion});